import { useFeatureFlagsContext } from '../contexts/FeatureFlagsContext';
import { getFeatureFlagDefinition } from '../services/featureFlagsRegistry';

export function useFeatureFlag(id: string): boolean {
  const { overrides } = useFeatureFlagsContext();
  const definition = getFeatureFlagDefinition(id);

  if (!definition) {
    if (import.meta.env.DEV) {
      throw new Error(
        `useFeatureFlag: unknown flag id "${id}". Add it to FEATURE_FLAGS in src/services/featureFlagsRegistry.ts.`,
      );
    }
    return false;
  }

  const override = overrides[id];
  if (override && typeof override.enabled === 'boolean') {
    return override.enabled;
  }
  return definition.defaultValue;
}
